import React, { useState } from 'react';
import './analysis-tools.css';
import MultiVariantSearch from './analysistools/multi-variant-search';
import SingularNetwork from './analysistools/SingularNetwork';

function AnalysisTools() {
  const [activeTab, setActiveTab] = useState('mvs');

  return (
    <div className="OCRP-analysis-tools">
      <div className="OCRP-analysis-tabs">
 

      </div>

      <div className="OCRP-analysis-content">
        {activeTab === 'mvs' && <MultiVariantSearch />}
      </div>
    </div>
  );
}

export default AnalysisTools;
